import { combineReducers } from 'redux';

import settings from './settings';
import permissions from './permissions';

export {
  fetchMetaSitePermissionsForUsers,
  updateMetaSitePermissionsForUser,
  fetchMetaSitePermissionsForUserGroups,
  updateMetaSitePermissionsForUserGroup,
} from './permissions';
export * from './settings';

export default combineReducers({
  settings,
  permissions,
});
